<template>
  <v-container class="mb-6">

    <error-dialog :status="loadStatus" />

    <dialog-scroll-lock
      v-if="share"
      content-class="overflow-visible" width="300"
      :value="true"
      @input="share = null"
    >
      <v-card class="relative pa-0">
        <v-btn style="top: -12px; right: -12px;" absolute x-small fab color="white" @click.stop.prevent="share = null">
          <v-icon v-html="mdiClose" />
        </v-btn>
        <social-share-btns
          class="pa-6"
          :title="post.title"
          :description="share.description"
          :url="`https://ellacard.com${$route.path}${share.href}`"
        />
      </v-card>
    </dialog-scroll-lock>

    <div>
      <v-btn exact :to="{ name: 'blog' }"><v-icon v-html="mdiChevronLeft" /> All blog posts</v-btn>
      <v-progress-circular v-if="loadStatus.pending" class="ml-4" indeterminate />
    </div>
    <template v-if="post">
      <div class="mt-6 blog-post">
        <h1 v-html="post.title" />
        <div class="grey--text text--darken-1 text-body-1 mb-6">
          {{post.author}} – {{(post.date + (new Date()).toISOString().slice(10)) | moment('long-date')}}
        </div>
        <social-share-btns link description="Ellacard blog post" :title="post.title" />
        <div ref="content" class="mt-9 mb-16" v-html="post.content" />
        <figcaption class="mb-3">This post was first published on Ellacard on {{(post.date + (new Date()).toISOString().slice(10)) | moment('long-date')}}</figcaption>
        <social-share-btns link description="Ellacard blog post" :title="post.title" />
      </div>

      <v-btn class="mt-16" exact :to="{ name: 'blog' }">
        <v-icon v-html="mdiChevronLeft" /> All blog posts
      </v-btn>
    </template>

  </v-container>
</template>

<style scoped>
@import '@/styles/blog.scss';
</style>

<script>
import SocialShareBtns from '@/components/SocialShareBtns.vue';
import { cache, ssr } from '@/mixins/ssr.js';
import { mdiChevronLeft, mdiClose } from '@mdi/js';

export default {
  name: 'blog-post',

  routerViewMeta: {
    description: 'Ellacard blog post'
  },

  mixins: [ ssr ],

  components: {
    SocialShareBtns
  },

  props: [ 'urlTitle' ],

  data() {
    return {
      post: null,
      loadStatus: this.$track('load'),
      share: null
    };
  },

  computed: {
    hydrated() {
      return !this.loadStatus.pending;
    },

    routerViewMeta() {
      if (!this.post)
        return {};
      return {
        title: this.post.title,
        image: this.post.img.src
      };
    }
  },

  created() {
    Object.assign(this, { mdiChevronLeft, mdiClose });
  },

  methods: {
    async load(url_title) {
      this.post = null;
      this.post = await cache(this.$call)('get-blog-post', { url_title });

      // This allows us to wrap web-media content with an anchor tag that links directly to it. The anchor that wraps
      // the web media (as generated by the admin-blog-editor) should resemble the following:
      // <a share-social-media href="#media:MEDIA_ID">
      //   <figure id="media:MEDIA_ID" ... />
      // </a>
      // Warning: this could still be pretty weird, since the link preview will use the blog's og image instead of the
      // one that's part of this media. You may want to introduce a new URL pattern that allows you to set the og
      // preview data via query parameters explicitly for link previews (since the hash fragment is not passed to the
      // server)
      await this.$nextTick();
      for (const el of this.$refs.content.querySelectorAll('a[share-social-media]'))
        el.onclick = e => {
          e.preventDefault();
          e.stopPropagation();
          this.share = {
            href: el.getAttribute('href'),
            description: el.querySelector('figcaption')?.innerText || ''
          };
        };

      for (const el of this.$refs.content.getElementsByClassName('slideshow')) {
        const slides = Array.from(el.children);
        for (const [ key, d ] of [ [ 'left', -1 ], [ 'right', 1 ] ]) {
          const btn = document.createElement('button');
          btn.className = key + ' v-btn v-btn--is-elevated v-btn--fab v-btn--round v-size--default';
          btn.onclick = e => {
            e.preventDefault();
            e.stopPropagation();
            const i = slides.findIndex(x => x.classList.contains('active'));
            slides[i].classList.remove('active');
            slides[ (slides.length + i + d) % slides.length ].classList.add('active');
          }
          el.appendChild(btn);
        }
        slides[0].classList.add('active');
      }
    }
  },

  watch: {
    urlTitle: {
      immediate: true,
      handler(v) {
        this.load(v);
      }
    }
  }
}
</script>
